import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { useTheme } from '../contexts/ThemeContext';
import { cn } from '../lib/utils';
import { formatAiMarkdown } from '../lib/formatAiMarkdown';

interface MarkdownContentProps {
  content: string;
  className?: string;
}

/**
 * Renders AI/markdown text with typography styles (headings, bold, lists, etc.).
 */
const MarkdownContent: React.FC<MarkdownContentProps> = ({ content, className }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const html = useMemo(
    () =>
      DOMPurify.sanitize(formatAiMarkdown(content), {
        USE_PROFILES: { html: true },
      }),
    [content],
  );

  return (
    <div
      className={cn(
        'prose prose-sm max-w-none',
        isDark && 'prose-invert',
        'prose-headings:font-semibold prose-headings:tracking-tight',
        'prose-p:my-2 prose-li:my-0.5',
        'prose-strong:font-semibold',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default MarkdownContent;
